<div class="wrapper">
	<span class="scenario">{{ scenarioName() }}</span>

	<div class="room">
		<mat-icon class="secondary" fontSet="fas" fontIcon="fa-door-open" inline />
		<label class="secondary"> {{ T.LABEL_ROOM | translate }}: </label>
		{{ roomName() }}
	</div>
</div>
